import reducerGenerator from '../utils/reducer-generator';
import cruReducerHelper from '../utils/cru-reducer-helper';
import requestStatuses from '../utils/request-statuses';

var read = reducerGenerator('read', requestStatuses.PENDING);
var readFail = reducerGenerator('read', requestStatuses.FAILED);
var readIdle = reducerGenerator('read', requestStatuses.IDLE);

function readSucceed(state, action, options) {
  return cruReducerHelper(state, action, options, {
    readStatus: requestStatuses.SUCCEEDED
  });
}

export { read, readFail, readIdle, readSucceed };